export { TrustBadgesDS } from './trust-badges-ds'
export type { TrustBadgeRow, TrustBadgesDSProps } from './trust-badges-ds.types'
